import {
  isStrategorRunningAtom,
  rdvToPostPoneDateAtom,
  useSelectedPatientIds,
  useSelectedWeek,
} from "../../main/state/globalState";
import {
  StrategorPatient,
  CadendarConsts,
  StrategorFilters,
} from "cadendar-shared";
import useFicheAppel from "./useFicheAppel";
import useTempPatient from "./useTempPatient";
import useRdvProposal from "./useRdvProposal";
import { useAtomValue } from "jotai";
import { useContraintes } from "./useContraintes";
import _ from "lodash";
import { trpc } from "../../main/components/trpc.ts";
import { strategorPatientSchema } from "cadendar-shared";
export default () => {
  const isStrategorRunning = useAtomValue(isStrategorRunningAtom); //todo : comment est-ce qu'on le met true ?
  const { rdvProposal } = useRdvProposal();
  const { duration, motifs } = rdvProposal;
  const convertedMotifs =
    motifs?.map((motif) => CadendarConsts.motifConsts[motif]) || [];
  const [selectedPatientIds] = useSelectedPatientIds();
  const { birthdate } = useFicheAppel();
  const { reffererType, reffererId } = useTempPatient();
  const strategorPatient: StrategorPatient | null = birthdate
    ? {
        ...{ birthdate },
        adr_id: reffererId || null,
        patient_flags: null,
        seen: null,
        former_patient: false,
      }
    : null;
  const { selectedWeek } = useSelectedWeek();
  const postPonedRdvDate = useAtomValue(rdvToPostPoneDateAtom);
  const { data: rdvCandidats, isFetched } =
    trpc.strategor.getRdvCandidates.useQuery(
      {
        weekDate: selectedWeek,
        duration,
        motifs: convertedMotifs,
        ...(selectedPatientIds.length > 0
          ? { patientIds: selectedPatientIds }
          : {}),
        ...(strategorPatientSchema.safeParse(strategorPatient).success
          ? { strategorPatient: strategorPatient! }
          : {}),
        ...(postPonedRdvDate ? { postPonedRdvDate } : {}),
      },
      { enabled: isStrategorRunning && !!strategorPatient }
    );
  const { contraintesConverted } = useContraintes();
  const filter = StrategorFilters.buildContraintesFilter(contraintesConverted);
  const rdvCandidatsFiltered = rdvCandidats
    ? filter(Object.values(_.groupBy(rdvCandidats, "date")))
    : [];
  return [rdvCandidatsFiltered, isFetched] as const;
};
